<div class="download-history-container">
    <mt-filter
        [filterConfig]="filterConfig"
        [progressBar]="filterConfig.isLoading"
        (filterChange)="getReportByFilters($event)"
    ></mt-filter>
    <div class="download-history-table mt-4" *ngIf="tableConfig">
        <div class="header-container">
            <div class="header">
                <div class="float-left">
                    <div class="title">
                        {{ "monthly-state-per-operator" | lang | uppercase }}
                    </div>
                </div>
                <div
                    class="float-right"
                    *ngIf="tableConfig.dataset?.length > 0"
                >
                    <app-button-icon
                        [image]="'download'"
                        [iconType]="'icon'"
                        [disabled]="disabledExcelBtn"
                        [spinner]="btnSpinner"
                        (clickHandler)="downloadReport()"
                    ></app-button-icon>
                </div>
            </div>
        </div>
        <div [ngClass]="{ 'body-container': tableConfig }">
            <app-main-table [tableConfig]="tableConfig"> </app-main-table>
        </div>
    </div>
</div>
